import {
  Form,
  Input,
  Upload,
  Button,
  Typography,
  UploadFile,
  Row,
  Col,
} from "antd";
import { ReactComponent as UploadIcon } from "../../../../assets/images/upload.svg";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CreateEntityInfo from "../../../shared/CreateEntityInfo";
import DepartmentSelector from "../../../shared/DepartmentSelector";
import PositionSelector from "../../../shared/PositionSelector";
import showNotification from "../../../../services/notificationService";
import UserSelector from "../../../shared/UserSelector";

const { Text } = Typography;
const { TextArea } = Input;

const CreateTaskScreen = (props: any) => {
  const {
    departments,
    positions,
    users,
    loading,
    actions: { getDepartment, getPosition, getUserByRole, createTask },
  } = props;

  const [fileList, setFileList] = useState<any>([]);
  const [selectedDepartments, setSelectedDepartments] = useState<string[]>([]);
  const [selectedPositions, setSelectedPositions] = useState<string[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    getDepartment();
    getPosition();
    getUserByRole("user");
  }, []);

  const handleSubmit = ({
    title,
    description,
  }: {
    title: string;
    description: string;
  }) => {
    if (
      selectedDepartments.length === 0 &&
      selectedPositions.length === 0 &&
      selectedUsers.length === 0
    ) {
      showNotification(
        "error",
        "Please select at least one department or one position or one user"
      );
      return;
    }
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    if (fileList.length > 0) {
      formData.append("coverImage", fileList[0].originFileObj as File);
    }
    selectedDepartments.forEach((departmentId: string) => {
      formData.append("departmentIds", departmentId);
    });
    selectedPositions.forEach((positionId: string) => {
      formData.append("positionIds", positionId);
    });
    selectedUsers.forEach((userId: string) => {
      formData.append("userIds", userId);
    });

    createTask({ task: formData, navigate });
  };

  const handleChange = ({ fileList }: { fileList: UploadFile[] }) => {
    setFileList(fileList);
  };

  const handleDepartmentChange = (departments: string[]) => {
    setSelectedDepartments(departments);
  };

  const handlePositionChange = (positions: string[]) => {
    setSelectedPositions(positions);
  };

  const handleUserChange = (users: string[]) => {
    setSelectedUsers(users);
  };

  return (
    <Row className="h-full">
      <Col lg={8}>
        <CreateEntityInfo
          title=""
          text={`Create a new task.
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. In, maxime. Pariatur quaerat nisi neque exercitationem.
            .`}
        />
      </Col>
      <Col lg={16} className=" max-w-[600px]">
        <Form layout="vertical" onFinish={handleSubmit}>
          <Text className="text-neutral-600 text-sm font-semibold">Title</Text>
          <Form.Item
            name="title"
            className="mt-2"
            rules={[{ required: true, message: "Please input the title!" }]}
          >
            <Input placeholder="Type the title here" />
          </Form.Item>

          <Text className="text-neutral-600 text-sm font-semibold">
            Description
          </Text>
          <Form.Item
            name="description"
            className="mt-2"
            rules={[
              { required: true, message: "Please input the description!" },
            ]}
          >
            <TextArea placeholder="Add description here" rows={10} />
          </Form.Item>

          <Text className="text-neutral-600 text-sm font-semibold">
            Cover Image
          </Text>

          <Form.Item
            name="coverImage"
            className="pb-6 sticky"
            rules={[
              { required: true, message: "Please upload a cover image!" },
            ]}
          >
            <Upload
              name="coverImage"
              listType="picture-card"
              maxCount={1}
              beforeUpload={() => false}
              accept="image/png, image/jpeg, image/gif"
              className="bg-white rounded-md h-[310px] mt-2"
              fileList={fileList}
              onChange={handleChange}
            >
              {fileList.length === 0 && (
                <div className="flex flex-col items-center justify-center">
                  <UploadIcon />
                  <p className="text-neutral-600 text-base font-medium">
                    Upload a cover image
                  </p>
                  <p className="text-xs text-neutral-500 font-normal">
                    PNG, JPG, GIF up to 5MB
                  </p>
                </div>
              )}
            </Upload>
          </Form.Item>

          <Text className="text-neutral-600 text-sm font-semibold">
            Assign Task
          </Text>

          <div className="mt-2 flex flex-col gap-2">
            <DepartmentSelector
              departments={departments}
              onSelectionChange={handleDepartmentChange}
              setSelectedDepartments={setSelectedDepartments}
              selectedDepartments={selectedDepartments}
            />
            <PositionSelector
              positions={positions}
              onSelectionChange={handlePositionChange}
              selectedPositions={selectedPositions}
              setSelectedPositions={setSelectedPositions}
            />
            <UserSelector
              users={users}
              onSelectionChange={handleUserChange}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
            />
          </div>
          <div className="w-full flex justify-end">
            <Form.Item className="w-2/4 my-5">
              <Button
                loading={loading}
                disabled={loading}
                type="primary"
                htmlType="submit"
                className="w-full h-[50px]"
              >
                {!loading ? "Continue" : "Loading"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Col>
    </Row>
  );
};

export default CreateTaskScreen;
